export const tabsContainerStyle = {
  marginBottom: '24px',
  '& .MuiButtonBase-root': { fontSize: '16px' }
};

export const tabsContentStyle = {
  width: '100%',
  height: 'calc(100% - 64px)'
};
